import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";

const KEYWORD_GROUPS = [
  {
    title: "Best IELTS Coaching in Hyderabad & Santosh Nagar",
    to: "/courses/ielts",
    keywords: [
      "Best IELTS classes in Hyderabad",
      "Best IELTS classes in Santosh Nagar",
      "Best IELTS training in Santosh Nagar",
      "Best IELTS coaching in Hyderabad",
      "Best IELTS training near me",
    ],
  },
  {
    title: "Best PTE Training in Hyderabad & Santosh Nagar",
    to: "/courses/pte",
    keywords: [
      "Best PTE training in Hyderabad",
      "Best PTE training in Santosh Nagar",
      "Best PTE coaching in Santosh Nagar",
      "Best PTE classes in Hyderabad",
      "Best PTE classes in Santosh Nagar",
      "Best PTE training near me",
    ],
  },
  {
    title: "Best Spoken English Classes in Hyderabad & Santosh Nagar",
    to: "/courses/spoken-english",
    keywords: [
      "Best Spoken English classes in Hyderabad",
      "Best Spoken English classes in Santosh Nagar",
      "Best Spoken English course in Hyderabad",
      "Best Spoken English course in Santosh Nagar",
      "Best Spoken English coaching in Santosh Nagar",
      "Best Spoken English coaching in Hyderabad",
    ],
  },
];

export default function LocalSEO() {
  return (
    <section
      id="local"
      data-testid="local-seo-section"
      className="py-24 md:py-28 bg-secondary/30 dark:bg-secondary/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-bold mb-4">
            <MapPin className="w-3.5 h-3.5" /> Serving Hyderabad · Santosh Nagar
          </div>
          <h2 className="text-4xl sm:text-5xl font-light tracking-tighter">
            Hyderabad's most trusted institute for{" "}
            <span className="font-serif italic text-gradient-royal">IELTS, PTE & Spoken English.</span>
          </h2>
          <p className="mt-5 text-muted-foreground text-lg leading-relaxed">
            Whether you searched for the <strong>best IELTS coaching in Hyderabad</strong>, the{" "}
            <strong>best PTE training in Santosh Nagar</strong>, or the{" "}
            <strong>best Spoken English classes near me</strong> — Globe Vista Overseas Education is
            Hyderabad's #1 destination. Our Santosh Nagar centre is easily accessible from Charminar,
            Malakpet, Kanchanbagh, Chandrayangutta, Falaknuma, DRDL and the greater Hyderabad region.
            Join 1000+ students who chose Hyderabad's most result-oriented institute for their global journey.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {KEYWORD_GROUPS.map((g) => (
            <Link
              key={g.to}
              to={g.to}
              data-testid={`local-seo-card-${g.to.split("/").pop()}`}
              className="group p-7 rounded-3xl bg-card border border-border hover:border-[#D4AF37]/60 hover:-translate-y-1 transition-all"
            >
              <h3 className="font-heading font-semibold text-xl leading-snug">{g.title}</h3>
              <ul className="mt-5 space-y-2">
                {g.keywords.map((k) => (
                  <li key={k} className="text-sm text-muted-foreground flex items-start gap-2">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#D4AF37] shrink-0" />
                    {k}
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-4 border-t border-border flex items-center gap-2 text-sm font-medium text-[#0F3D8C] dark:text-[#60A5FA] group-hover:gap-3 transition-all">
                Explore programme <ArrowUpRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
